import { useState, useEffect } from 'react'
import CardProduct from 'newComponents/cardProduct/addGifts'
import { useStore } from 'store';
import { hideLoader, showLoader } from 'store/actions/commons';
import useProductsIDs from 'newHooks/useProductsIDs';

import PaginationList from 'newComponents/pagination';
import styles from './styles.module.sass';


const GridProductResult = (props) => {
    const {
        resultsSearch,
        setPage,
        activeView,
        page
    } = props

    const [, dispatch] = useStore((state) => state.giftTable.giftTable);
    const { getProductsByFilter, responseProduct } = useProductsIDs()

    const [cantResults, setCantResults] = useState()
    const [productResults, setProductResults] = useState()
    const [cantResultPerPage, setCantResultPerPage] = useState()
    useEffect(() => {
        if(resultsSearch){
            if( !Number.isNaN( Number(resultsSearch?.totalResults) )){
                setCantResults( Number(resultsSearch?.totalResults) )
            }
            setProductResults(resultsSearch?.productIDs)
            setCantResultPerPage(resultsSearch?.resultsPerPage)
        }
    },[resultsSearch])

    useEffect(()=>{
        if(productResults){
            dispatch(showLoader());
            getProductsByFilter( productResults )
        }
    },[productResults])

    useEffect(()=>{
        if(responseProduct){
            dispatch(hideLoader());
        }
    },[responseProduct])

    return(
        <div className={styles?.columnRight}>
            <div>
                
                <div className={`${styles?.contCardsProducts} ${activeView}`}>
                    {responseProduct && 
                        responseProduct.map(product => <CardProduct key={product?.id} item={product} modalNormalProduct />)
                    }
                </div>
                
                <PaginationList
                    setPage={setPage}
                    selectedPage={page || 1}
                    cantResults={cantResults}
                    cantResultPerPage={cantResultPerPage}
                />
            </div>
        </div>
    )
}

export default GridProductResult